import { useTranslations } from "next-intl"
import Heading from "../Heading"
import { testimonials } from "@/constants/testimonials"
import { TestimonialsCarousel } from "./TestimonialsCarousel"
import ScrollFadeIn from "@/components/shared/animations/ScrollFadeIn"
import ScrollSlideRight from "@/components/shared/animations/ScrollSlideRight"
import ScrollSlideLeft from "@/components/shared/animations/ScrollSlideLeft"

const Testimonials = () => {

    const t = useTranslations("Home.testimonials")

    return (
        <div className="w-full flex flex-col lg:flex-row items-center justify-between">
            <div className="w-full md:w-1/3">
                <ScrollSlideRight >
                    <Heading id="testimonials" title={t("title")} subTitle={t("subTitle")} />
                </ScrollSlideRight>
            </div>

            <div >
                <ScrollSlideLeft>
                    <TestimonialsCarousel testimonials={testimonials} />
                </ScrollSlideLeft>
            </div>
        </div >
    )
}

export default Testimonials;